/**
 * dbapi token 处理工具
 * dbapi 使用独立的 token 存储和管理机制
 */

const DBAPI_TOKEN_KEY = 'neolix_dbapi_openapi_token'

/**
 * 获取 dbapi token
 */
export function getDBApiToken(): string | null {
  return localStorage.getItem(DBAPI_TOKEN_KEY)
}

/**
 * 设置 dbapi token
 */
export function setDBApiToken(token: string): void {
  localStorage.setItem(DBAPI_TOKEN_KEY, token)
}

/**
 * 清除 dbapi token
 */
export function removeDBApiToken(): void {
  localStorage.removeItem(DBAPI_TOKEN_KEY)
}
